module.exports = __webpack_public_path__ + "static/media/404.9fee8b03.svg";